import { Component, OnInit, OnDestroy, ChangeDetectorRef, inject} from '@angular/core';
import { EventsService } from 'src/app/core/services/events.service';
import { AARoutePlannerEvents, AAGoogleMapEvents, MapContextMenuEvents} from 'src/app/core/events/events';
import { RoutePlannerSummaryService} from '../../services/route-planner-summary/route-planner-summary.service';
import { RoutePlannerOptionsData, RoutePlannerSummaryData } from '../../models/route-model';
import { RoutePlannerService } from '../../services/route-planner/route-planner.service';
import { SummaryData } from '../../models/route-summary-model';
import { GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { GoogleTagService } from 'src/app/modules/aa-core/services/gpt.service';

@Component({
    selector: 'aa-route-summary',
    templateUrl: './route-summary.component.html',
    styleUrls: ['./route-summary.component.scss'],
    standalone: false
})
export class RouteSummaryComponent implements OnInit, OnDestroy {

  // public routeSummary:Array<SummaryData> = [];
  public avoidTrafficCheck;
  private isRouteRadioClicked = false;
  private summaryData: RoutePlannerSummaryData;
  public routeOptionsData: RoutePlannerOptionsData;
  public isRouteDirectionErrorFlag = false;
  private readonly googleTagService = inject(GoogleTagService)

  constructor(private eventsService: EventsService,
    private cdr: ChangeDetectorRef,
    private routePlannerService: RoutePlannerService,
    private routePlannerSummaryService: RoutePlannerSummaryService) {}

  ngOnInit() {
    this.summaryData = this.routePlannerService.routeDataModel.SummaryData;
    // this.routeSummary = this.summaryData.SummaryDataList;

    this.eventsService.on(AARoutePlannerEvents.UPDATE_SUMMARY, this.updateSummaryData);
    this.eventsService.on(MapContextMenuEvents.ROUTE_DIRECTION_ERROR, this.routeDirectionError);
  }

  ngOnDestroy() {
    this.eventsService.remove(AARoutePlannerEvents.UPDATE_SUMMARY, this.updateSummaryData);
    this.eventsService.remove(MapContextMenuEvents.ROUTE_DIRECTION_ERROR, this.routeDirectionError);
  }

  get routeSummary(): Array<SummaryData> {
    return this.summaryData.SummaryDataList;
  }

  updateSummaryData = (data) => {
    if (this.isRouteRadioClicked != true) {
      this.routePlannerSummaryService.parseRouteSummaryData(data);
      // this.routeSummary = this.summaryData.SummaryDataList;

      // reset
      this.summaryData.SelectedAltRoute = 0;

      // Sort the summary data based on duration
      // this.summaryData.SummaryDataList = this.sortRouteByDuration();

      const selectedSummaryData = this.summaryData.getSelectedSummaryData();
      // this.eventsService.dispatch(AAGoogleMapEvents.HIGHLIGHT_ROUTE, {route: selectedSummaryData, visible:true});
      this.eventsService.dispatch(AARoutePlannerEvents.UPDATE_SIGNSPOTS, selectedSummaryData);
    }

    this.isRouteRadioClicked = false;
    this.apply();
  }

  apply() {
    this.cdr.detectChanges();
    if (this.summaryData) {
      const selectedRoute = this.summaryData.SummaryDataList[this.summaryData.SelectedAltRoute];
      if (selectedRoute?.legs[0]['start_address'] && selectedRoute?.legs[0]['end_address']) {
        const start = selectedRoute.legs[0]['start_address'].split(',').at(-2).trim().replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
        const end = selectedRoute.legs[0]['end_address'].split(',').at(-2).trim().replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
        this.googleTagService.updateGlobalTargeting({
          origin: start,
          destination: end,
          journeyLength: selectedRoute.journeyLengthForTargetting
        });
      }
    }
  }

  getViaRoute(item: SummaryData): string {
    return `Via <span class='summary-name'>${item.Summary} </span> - ${item.formatDuration} - ${ item.formatDistance }`;
  }

  // Call this method, if we need to sort the summary data based on distance
  sortRouteByDistance () {
    return this.summaryData.SummaryDataList.sort( (a, b) => a.Distance[0].value - b.Distance[0].value );
  }

  // Call this method, if we need to sort the summary data based on duration
  sortRouteByDuration () {
    return this.summaryData.SummaryDataList.sort( (a, b) => a.Duration[0].value - b.Duration[0].value );
  }

  getToogleButtonLabel(item: SummaryData) {
    return ` (show in ${item.getToggleDistanceType})`;
  }

  onShowInMileKM(routeItem: SummaryData) {
    this.routeSummary.forEach((routeSummaryItem: SummaryData) => {
      routeSummaryItem.toggle();
    });

    this.summaryData.DistanceType = routeItem.DistanceType;
    this.eventsService.dispatch(AARoutePlannerEvents.UPDATE_SUMMARY_MATRIC, this.summaryData.DistanceType);

    this.apply();
  }

  onChangeSelectedRoute(item: any, index: number) {
    item.selectedAltRoute = true;
    this.isRouteRadioClicked = true;
    this.summaryData.SelectedAltRoute = index;

    this.eventsService.dispatch(AAGoogleMapEvents.UPDATE_MAP, GoogleMapType.ROUTE_PLANNER);
    this.eventsService.dispatch(AARoutePlannerEvents.UPDATE_SIGNSPOTS, item);
  }

  onMouseOver(item, index) {
    if (this.summaryData.SelectedAltRoute != index) {
      this.eventsService.dispatch(AAGoogleMapEvents.HIGHLIGHT_ROUTE, { route: item, visible: true });
    }
  }

  onMouseOut(item, index) {
    this.eventsService.dispatch(AAGoogleMapEvents.HIGHLIGHT_ROUTE, { route: item, visible: false });
  }

  routeDirectionError = (event: any) => {
    this.isRouteDirectionErrorFlag = event;
    this.apply();
  }

  onFocusOption(ind) {
    const id = 'routeOption' + ind;
    const el: HTMLElement = document.getElementById(id);
    el.classList.add('focus');
  }

  onBlurOption(ind) {
    const id = 'routeOption' + ind;
    const el: HTMLElement = document.getElementById(id);
    el.classList.remove('focus');
  }
  
  trackByFn(index: number): number {
    return index;
  }
}
